import { createSelector } from 'reselect'
import { get } from 'lodash'
import { sameIdsIn } from 'utils/array'
import mapInvitedParticipantsForBulk from './mapInvitedParticipantsForBulk'

const getSelectedIds = state => get(state,
  'api.tasks.invitedParticipants.selectedIds',
  []).map(item => item.participantRegistrationId)

const getSelectableIds = state => mapInvitedParticipantsForBulk(state)
  .map(item => item.participantRegistrationId)

const areAllSelected = (selectedIds, selectableIds) => {
  return selectedIds.length > 0 && sameIdsIn(selectedIds, selectableIds)
}

export default createSelector([getSelectedIds, getSelectableIds],
  areAllSelected)
